exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".formly-field>div:not(.ng-hide){min-height:85px}.formly-field>.k-content{background:none !important}[csscategory=bssplaintext]{color:gray !important;background:#f5f5f5 !important}.htmlselectingrid{color:#000}", ""]);

// exports
